module.exports = __webpack_public_path__ + "static/img/14000121.3830367b.png";